import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import bgLoading from 'static/bg-loading.webp';
import icHome from 'static/ic-home.png';
import bgHome from 'static/bg-home.png';
import './Splash.scss'
import { history } from "store";
import { handleNativeAction } from "helpers/nativeActions";
import { NATIVE_ACTION } from "helpers/constants";
import ModalUnexpected from "./ModalUnexpected";
import { getGameAsset } from "helpers/gameAssets";
import mb32BgLoading from 'static/mb32/bg-loading.webp';
import mb32BgHome from 'static/mb32/bg-home.png';
import mb32BgRodal from 'static/mb32/bg-rodal.png';

const BackgroundImage = styled.img`
  position: absolute;
  height: 100vh;
  width: 100vw;
  object-fit: cover;
  object-position: center;
  z-index: -9999;
`
const Wrapper = styled.div`
// background-image: url(${bgLoading});
background-repeat: no-repeat;
background-size: cover;
background-position: bottom;
`
const Background = styled.div`
  width: 100vw;
  height: 100vh;
  background-image: url(${bgHome});
  background-repeat: no-repeat;
  background-size: cover;
`
let interval = undefined;
class SplashScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      percent: 30,
      isOpenModal: false,
      userGameCodeList: [],
      gameCode: new URL(window.location.href).searchParams.get("gameCode"),
      config: {
        btnLabel: "TRỞ LẠI APP MB",
        message: `Hiện tại không có chương trình quay ong nào.\n Vui lòng quay trở lại sau`,
        callback: () => handleNativeAction(NATIVE_ACTION.ONG_VANG_WEB, { action: "quit" })
      }
    }
    handleNativeAction(NATIVE_ACTION.INS_QUAYONG_VIEW, { ins_transaction_type: "ladingpage" });
  }

  componentDidMount() {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");
    const gameCodeSpecified = url.searchParams.get("gameCode");
    const destination = url.searchParams.get("page");
    this.props.updateToken(token);
    this.getListGame(gameCodeSpecified, destination);
  }

  componentWillUnmount() {
    clearInterval(interval);
  }

  getListGame = async (gameCode, destination) => {
    // const { userGameCodeList } = this.state;
    interval = setInterval(() => {
      this.setState((preState, preProps) => {
        if (preState.percent === 100) {
          clearInterval(interval);
          return { percent: preState.percent };
        } else {
          return { percent: preState.percent + 5 };
        }
      });
    }, 500);
    const result = await this.props.getGameCodeList();
    const userGameCodeList = result && result.userGameCodeList ? [...result.userGameCodeList] : [];
    this.setState({ gameCode: gameCode || userGameCodeList[0]?.gameCode });
    if (this.state.percent < 90) {
      this.setState({ percent: 90 });
    }

    setTimeout(async () => {

      if (userGameCodeList.length > 0) {
        // Open game from notify or deeplink
        if (gameCode) {
          const game = userGameCodeList.find(item => item.gameCode === gameCode);
          if (game && game.userGameStatus === "ACTIVE") {
            const info = await this.props.getInfo({ gameCode });
            // If gameCode exist in listgame and game active, Redirect to Home Page
            if (info && info.result.ok) {
              handleNativeAction(NATIVE_ACTION.INS_QUAYONG_VIEW, { ins_transaction_amount_int: info.currentPoint, ins_transaction_type: "vao_game" });
              history.push("/home", { gameInfo: info, gameCode: gameCode, destination, isFromSplash: true });
            }
          } else {
            this.setState({ isOpenModal: true });
          }
        } else {
          if (userGameCodeList.length < 2) {
            // If have only 1 game and this game active
            // Route to home page
            if (userGameCodeList[0].userGameStatus === "ACTIVE") {
              const info = await this.props.getInfo({ gameCode: userGameCodeList[0].gameCode });
              if (info && info.result.ok) {
                handleNativeAction(NATIVE_ACTION.INS_QUAYONG_VIEW, { ins_transaction_amount_int: info.currentPoint, ins_transaction_type: "vao_game" });
                history.push("/home", { gameInfo: info, gameCode: userGameCodeList[0].gameCode, isFromSplash: true });
              } else if (info && !info.result.ok && (info.result.responseCode === "GW100" || info.result.responseCode === "GW582")) {
                this.setState({
                  config: {
                    btnLabel: "TRỞ LẠI APP MB",
                    message: `Chương trình đã kết thúc.\nVui lòng theo dõi các chương trình khuyến mãi tiếp theo từ MBBank nhé.`,
                    callback: () => handleNativeAction(NATIVE_ACTION.ONG_VANG_WEB, { action: "quit" })
                  },
                  isOpenModal: true
                })
              }
              // If have 1 game but not active, show list game
            } else {
              handleNativeAction(NATIVE_ACTION.INS_QUAYONG_VIEW, { ins_transaction_type: "gioi_thieu" });
              history.push("/listgames", { userGameCodeList: [...userGameCodeList] });
            }
            // If have more than 1 game, show list game
          } else {
            handleNativeAction(NATIVE_ACTION.INS_QUAYONG_VIEW, { ins_transaction_type: "gioi_thieu" });
            history.push("/listgames", { userGameCodeList: [...userGameCodeList] });
          }
        }
      } else {
        this.setState({ isOpenModal: true });
      }
    }, 1700);

  }

  render() {
    const { percent, isOpenModal, config } = this.state;
    const loadingBackground = getGameAsset(this.state.gameCode, 'bg-loading', mb32BgLoading);
    const homeBackground = getGameAsset(this.state.gameCode, 'bg-home', mb32BgHome);
    return (
      <div>
        <BackgroundImage src={loadingBackground} />
        {!isOpenModal && <Wrapper className="container splash">
          <img className="icon-header absolute"
            style={{ top: "1rem", left: "7vw" }}
            src={icHome} alt="home"
            onClick={() => handleNativeAction(NATIVE_ACTION.ONG_VANG_WEB, { action: "quit" })} />
          <div className="loading-cover">
            <div className="loading">
              <div className="progress-bar" style={{ width: `${percent}%` }}>
                {/* <div className="flex justify-content-center">
                  <label className="loading-text" style={{ paddingLeft: `${textPadding}px` }}>Đang tải...</label>
                </div> */}
              </div>
              <label className="loading-text">Đang tải...</label>
            </div>
          </div>

        </Wrapper >}
        {isOpenModal && <Background style={{ backgroundImage: `url(${homeBackground})` }}>
          <ModalUnexpected
            isOpen={isOpenModal}
            onCloseModal={config.callback}
            message={config.message}
            btnLabel={config.btnLabel}
            gameCode={this.state.gameCode} 
            backgroundImage={`url(${getGameAsset(this.state.gameCode, 'bg-rodal', mb32BgRodal)})`} />
        </Background>}
      </div>

    );
  }
}

SplashScreen.propTypes = {
  updateToken: PropTypes.func.isRequired,
  getGameCodeList: PropTypes.func.isRequired,
  getInfo: PropTypes.func.isRequired
};

export default SplashScreen;